var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._l((_vm.type),function(item){return [(item.value == _vm.value)?_c('span',[_vm._v(" "+_vm._s(item.label))]):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }